<template>
  <div class="header-contents" style="">
    <div id="web-menu">
      <header>
        <a v-on:click="menu()"><img id="sp-menu" src="../../assets/humbarger-menu.png"  alt="スマホメニュー"></a>
        <a href="/"><h1 id="top-titile"><img src="../../assets/logo.png" id="header-image" alt="株式会社weart"></h1></a>
          <ul v-show="isNoLogin">
            <a href="/plan"><li>会員登録</li></a>
            <a href="/login"><li>ログイン</li></a>
          </ul>
          <a v-show="isLogin" v-on:click="mypage()"><img src="../../assets/mypage.png" id="mypage" alt="マイページ"></a>
          <a v-show="isLogin" v-on:click="logout()"><img src="../../assets/logout.png" id="logout" alt="ログアウト"></a>
        </header>
    </div>
    <div id="sp-menu">
      <header>
        <a v-on:click="menu()"><img id="menu" src="../../assets/humbarger-menu.png"  alt="スマホメニュー"></a>
        <a href="/"><h1 id="top-titile"><img src="../../assets/logo.png" id="header-image" alt="株式会社weart"></h1></a>
        </header>
    </div>
    <div v-show="isMenu" class="pop sp">
      <ul v-show="isNoLogin">
            <a href="/plan"><li>＞　会員登録</li></a>
            <a href="/login"><li>＞　ログイン</li></a>
      </ul>
      <ul v-show="isLogin">
            <a v-on:click="mypage()"><li>＞　マイページ</li></a>
            <a v-on:click="logout()"><li>＞　ログアウト</li></a>
      </ul>
    </div>
  </div>
</template>
<style scoped>
header {
height: 80px;
width: 100%;
  background: black;
}
h1 {
  margin-bottom: 0px;
  margin-top: 0px;
}
header{
  position: relative;
}

header h1 img{
  height: 48px;
  position: absolute;
  top:16px;
  left:5%;
}
#mypage{
  height: 36px;
  position: absolute;
  top:22px;
  right:10%;
}
#logout{
  height: 36px;
  position: absolute;
  top:22px;
  right:5%;
}
header ul img{
  height: 40px;
  width: 40px;
}
a {
  text-decoration: none;
}
header ul {
  display: inline-block;
  position: absolute;
  top:30px;
  right:10%;
  height: 100px;
  margin-top: 0px;
  margin-bottom: 0px;
  list-style: none;
}
header li {
  margin-left: 16px;
  display: inline-block;
  color: white;
}
.pop {
  height: auto;
  background: black;
}
.pop ul{
  margin:0px;
  padding-left: 0px;
  color: white;
  text-decoration: none;
}
.pop ul li{
  padding: 36px;
  color: white;
}
.cartNum {
  background: orange;
  font-size: 15px;
  padding: 1px;
  width: 16px;
  height: 16px;
  text-decoration: none;
  color: white;
  border-radius: 50%;
}
.sp {
  display: none;
}
#sp-menu{
  display: none;
}
@media screen and (max-width:780px){
  header {
height: 80px;
width: 100%;
  background: black;
}
header h1 img{
  height: 40px;
  margin-top: 20px;
}

  header ul img{
  height: 30px;
  width: 30px;
}
header ul {
  display: inline-block;
  position: absolute;
  top:25px;
  right:25px;
  height: 100px;
  margin-top: 0px;
  margin-bottom: 0px;
  list-style: none;
}
}
@media screen and (min-width:781px){

}
@media ( max-width : 600px ){
  header ul {
    display: none;
  }
  header h1 img{
  height: 48px;
  width: 30%;
  position: absolute;
  top:0px;
  left:35%;
}
#web-menu{
  display: none;
}
#sp-menu{
  display: block;
}
.sp {
  display: block;
}
#menu{
  height: 48px;
  position: absolute;
  top:16px;
  left:5%;
}
}
</style>
<script>
export default {
  name: 'Header',
  data () {
    return {
      cartNum: null,
      isCart: false,
      isNoLogin: true,
      isLogin: false,
      isMenu: false,
    }
  },
  created: function () {
    console.log('---------------')
    console.log(localStorage.userId)
    console.log('---------------')
    if (!localStorage.userId) {
      console.log('AAAAAAAAAaa')
      this.isNoLogin = true
      this.isLogin = false
    } else {
       console.log('BBBBBBB')
      this.isNoLogin = false
      this.isLogin = true
    }
  },
  methods: {
    mypage: function () {
      location.href = '/mypage?userId=' + localStorage.userId
    },
    logout: function () {
      localStorage.clear()
      location.href = '/'
    },
    menu: function () {
      if (this.isMenu === true) {
        this.isMenu = false
      } else {
        this.isMenu = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Header.vue